import React, { useCallback, useEffect, useState } from 'react';
import { Modal, TitleBar,SaveBar } from "@shopify/app-bridge-react";
const SourceRequestModal = ({
    handleDifferentModalOpen,
    handleModalOperateData
})=> {
    // Shopify 属性
    const shopify = window.shopify;

    const [editState, setEditState] = useState(false); // 是否可以操作
    const [barState, setBarState] = useState(false);   // 是否显示了保存bar
    const modalHideAction = ()=>{
        handleDifferentModalOpen(false,'/admin/product_selection?select_tab=2')
    }
     // 舍弃保存
  const handleDiscard = () => {
    if (editState && shopify) {
      shopify.saveBar.hide("SaveBar_SDM");
      handleModalOperateData('discard',"Sourcing_Detail_Modal")
      setBarState(false);
    }
  };

  // 内容保存
  const handleSave = () => {
    if (editState && shopify) {
        handleModalOperateData('save',"Sourcing_Detail_Modal")
    }
  }
    // 接收子窗口
    const handleFromModalOperate = useCallback((event) => {
      const _that = event.data;
      const _type = _that?.mode || "";
      if (_that?.state === "Edit" && shopify) {
        if (_type === "save") {
          shopify.saveBar.hide("SaveBar_SDM");
          setBarState(false);
        } else if (_type === "showSaveBar") {
          setEditState(true);
          if (!barState) {
            shopify.saveBar.show("SaveBar_SDM");
            setBarState(true);
          }
        } else if (_type === "hideSaveBar") {
          shopify.saveBar.hide("SaveBar_SDM");
          setBarState(false);
        }
      }
    }, [barState,shopify]); // 依赖 barState
    

  useEffect(() => {
    window.addEventListener("message", handleFromModalOperate)
    return () => {
      window.removeEventListener("message", handleFromModalOperate)
    }
  }, [handleFromModalOperate])
    return (
        <Modal id="Sourcing_Detail_Modal" src="/admin/product_selection/sourcing-detail" variant={"max"} onHide={modalHideAction}>
        <TitleBar title={"DSM - Sourcing Request"} />
        <SaveBar id="SaveBar_SDM" discardConfirmation="">
            <button onClick={handleDiscard}></button>
            <button variant="primary" onClick={handleSave}></button>
        </SaveBar>
    </Modal>
    );
}

export default SourceRequestModal;
